import { render } from "./InternationalCurrencyField.vue?vue&type=template&id=106c0697"
import script from "./InternationalCurrencyField.vue?vue&type=script&lang=js"
export * from "./InternationalCurrencyField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"InternationalCurrencyField.vue"]])

export default __exports__